import React, { FC } from 'react';
import i18n from 'i18n';

import { ModalProps } from '../types';
import Dialog from '../../Dialog/index';

interface WaitModalProps extends ModalProps {}

export const WaitModal: FC<WaitModalProps> = ({ onCancel, onSuccess }) => (
  <Dialog
    show={true}
    id="WaitModal"
    title={i18n('page.Clock.InstallButtonWaitModal.title')()}
    message={i18n('page.Clock.InstallButtonWaitModal.content')()}
    onDismiss={onSuccess}
    actions={[
      {
        id: 'wait-modal-ok',
        text: i18n('page.Clock.InstallButtonWaitModal.button')(),
        onClick: onCancel,
        variant: 'filled'
      }
    ]}
  />
);

export default WaitModal;